'use strict';

//const _ = require('lodash');
const React = require('react');
const PropTypes = require('prop-types');

const ShortCourseEditorActions = require('../../../actions/ShortCourseEditorActions');

const propTypes = {
    showingComments: PropTypes.bool.isRequired,
    navLoc:  PropTypes.object.isRequired,
    addComment: PropTypes.func,
    
    // forge additions
    hasOpenComment: PropTypes.func.isRequired,
    selectedCommentIsInNavLoc: PropTypes.func.isRequired,
    canAddComment: PropTypes.bool, // userPermissions ? userPermissions.addComment : false
    showCommentsAtLoc: PropTypes.func.isRequired,
};

class GotoCommentIcon extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.getStateFromProps(props);
    }
    
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState(this.getStateFromProps(nextProps));
    }
    
    getStateFromProps=(props)=>{
        const hasOpenComment = props.hasOpenComment(props.navLoc);
        const isShowingComment = props.showingComments && props.selectedCommentIsInNavLoc(props.navLoc);
        
        return {
            hasOpenComment: hasOpenComment, 
            isShowingComment: isShowingComment,
        };
    }
    
    gotoComment=(evt)=>{
        evt.stopPropagation();
        this.props.showCommentsAtLoc(this.props.navLoc);
    }
    
    addComment=(evt)=>{
        evt.stopPropagation();
        this.props.addComment(this.props.navLoc);
    }
    
    render() {
        if (!this.state.hasOpenComment) {
            if (this.props.addComment && this.props.canAddComment) {
                return (
                    <span className="comment-add-icon" role="button" title="add comment" onClick={this.addComment}>
                        <i className="fas fa-comment-alt"/> 
                        <i className="far fa-comment-alt"/>
                        <i className="fas fa-plus"/>
                    </span>
                );
            }
            return null;
        }
        if (this.state.isShowingComment) {
            return (
                <i className="comment-goto-icon fas fa-comment-alt" role="button" title="go to comment" onClick={this.gotoComment}/>
            );
        }
        return (
            <span className="comment-yellow-icon" role="button" title="go to comment" onClick={this.gotoComment}>
                <i className="fas fa-comment-alt"/> 
                <i className="far fa-comment-alt"/>
            </span>
        );
    }
}; // GotoCommentIcon

GotoCommentIcon.propTypes = propTypes;

module.exports = GotoCommentIcon;